<ng-container *ngIf="properties | async as props">
  <ng-container *ngIf="props.toggleDispatcher$ | async">
    <aside class="dynamic-side-menu-container right montserrat-font" tabindex="0">

      <div class="menu right panel-res d-flex fd-col">
        <div class="handle-container">
          <div class="handle d-none d-md-block"></div>
        </div>
        <section
          class="title d-flex border-title bg-color-background-1 bg-md-white align-items-center border-md-top-right-25 border-md-top-left-25 pt-md-15"
          SheetBottom classContainer="menu">
          <div class="d-flex full-width border-title title-icons align-items-center">
            <div class="icon-main">
              <sit-icon [icon]="props.titleIcon" class="d-flex" [sizeClass]="'icon-size-auto'"
                [alt]="props.alt"></sit-icon>
            </div>
            <div class="icon-secondary">
              <sit-icon *ngIf="props.titleIconAux" [icon]="props.titleIconAux" class="d-flex"
                [sizeClass]="'icon-size-34'" [alt]="props.alt"></sit-icon>
            </div>
            <h2 class="py-05 flex-grow text-weight-600 text-size-28 ml-16 text-md-size-22 text-white align-self-center">
              {{ props.title }}
            </h2>
            <sit-icon-button [alt]="'Cerrar'" (click)="toggleMenu()" (click)="disableClickDispatcher()"
              [icon]="Icon.close_ng" [colorClass]="'text-white'" class="py-05 mr-16">
            </sit-icon-button>
          </div>
        </section>

        <section class="content  custom-scrollbar overflow-y-auto">
          <ng-container *ngIf="props.content as toRender; else ngContent">
            <ng-container *ngIf="ToastService.isComponentVisible$ | async">
              <sit-renderer [toRender]="toRender"></sit-renderer>
            </ng-container>
          </ng-container>
          <ng-template #ngContent>
            <ng-content></ng-content>
          </ng-template>
        </section>
        <ng-container *ngIf="(sideMenuService.subpanelState$| async) as subpanel">
          <section *ngIf="subpanel.component && subpanel.data" class="subpanel text-color-white">
            <div class="subpanel-title">
              <!-- <sit-icon *ngIf="subpanel.data.title" [alt]="'Cerrar'" [icon]="subpanel.data.title.icon"
                [colorClass]="'text-white'" sizeClass="icon-size-32" class="text-blue" /> -->
              <span class="title-panel">
                {{subpanel.data.title ?? subpanel.data.id ?? 'Sin info'}}
              </span>
              <sit-icon-button [alt]="'Cerrar'" (click)="toggleMenu(true)" (click)="disableClickDispatcher()"
                [icon]="Icon.close_x" sizeClass="icon-size-16" [colorClass]="'text-white'" class="text-blue" />
            </div>
            <sit-renderer [toRender]="subpanel"></sit-renderer>
          </section>
        </ng-container>
      </div>
    </aside>
  </ng-container>
</ng-container>